import { useLocal } from "@/pages/dashboard/utils/customHook";
import { getMonetUnit } from "@/pages/dashboard/utils/moneyUnit";

const useMetrics = () => {
  const { getLocalText } = useLocal();
  
  return [
    {
      name: getLocalText('ua_table_Install'),
      key: 'install',
      isPercent: false,
      stack: 'bar'
    },
    {
      name: getLocalText('ua_table_Register'),
      key: 'register',
      isPercent: false,
      stack: 'bar'
    },
    {
      name: getLocalText('ua_D2'),
      key: 'd2',
      isPercent: true,
    },
    {
      name: getLocalText('ua_D3'),
      key: 'd3',
      isPercent: true,
    },
    {
      name: getLocalText('ua_D7'),
      key: 'd7',
      isPercent: true,
    },
    {
      name: getLocalText('ua_spend',{unit:getMonetUnit()}),
      key: 'spend',
    },
    {
      name: getLocalText('ua_cpiTab',{unit:getMonetUnit()}),
      key: 'cpi',
    },
    {
      name: getLocalText('ua_cpaTab',{unit:getMonetUnit()}),
      key: 'cpa',
    },
    {
      name: getLocalText('ua_roasTab'),
      key: 'roas',
      isPercent: true,
    },
    {
      name: getLocalText('ua_LTV3'),
      key: 'ltv_3',
    },
  ]
}

export default useMetrics